import mapStyle from './map-styles/apple'
export default {
  disableDefaultUI: true,
  draggable: true,
  zoomControl: false,
  scrollwheel: true,
  disableDoubleClickZoom: false,
  gestureHandling: 'cooperative',
  styles: mapStyle
}



// WEBPACK FOOTER //
// ./src/values/map-settings.js